import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _AddSomeone from './add-someone.vue';

const AddSomeone = Object.assign(_AddSomeone, {
  install: (app: App, options?: ArcoOptions) => {
    setGlobalConfig(app, options);
    const componentPrefix = getComponentPrefix(options);

    app.component(componentPrefix + _AddSomeone.name, _AddSomeone);
  },
});

export type AddSomeoneInstance = InstanceType<typeof _AddSomeone>;

export default AddSomeone;
